import React from 'react'
import { useState, useEffect } from 'react'
import Button from '/react4xp/components/Button'

interface Props {
   title: string,
   intro?: string,
   img?: {
      src: string,
      srcMobile: string,
      alt: string,
   },
   cards?: {
      title: string,
      content?: string,
   }[],
   cta?: {
      label: string,
      url: string,
      isExternal?: boolean,
   },
   color: string,
   headingLevel?: 2 | 3 | 4 | 5 | 6,
}

export default function CardsUSP(props: Props) {
   const { title, intro, img, cta, cards, color, headingLevel = 2 } = props

   // a freely-placed section part cannot know its own depth, so the level is set
   // where the page is composed; 2 is right wherever the page title is the only h1
   const Heading = `h${headingLevel}` as const

   const [isMobile, setIsMobile] = useState<boolean>(false)

   useEffect(() => {
      const handleResize = () => {
         const width = window.innerWidth

         if (width < 768) {
            setIsMobile(true)
         } else {
            setIsMobile(false)
         }
      }

      handleResize()

      window.addEventListener('resize', handleResize)

      return () => window.removeEventListener('resize', handleResize)
   }, [])

   return (
      <div className={`grid-container cards-usp ${color === 'primary' ? 'color-primary' : 'color-secondary'}`}>
         <div className="cards-usp__wrapper">
            <div className="grid-row header">
               <div className="c-md-5 wrapper">
                  {title && <Heading className="title font-title">{title}</Heading>}
                  {intro && <div className="intro">{intro}</div>}
               </div>
               {img && (
                  <figure className="c-md-6 start-md-7">
                  <picture>
                     
                     <source
                        media="(min-width: 768px)"
                        srcSet={img.src}
                     />

                     {img.srcMobile && (
                        <source
                           media="(max-width: 767px)"
                           srcSet={img.srcMobile}
                        />
                     )}
                     
                     <img src={img.src} alt={img.alt ? img.alt : 'Image'} loading='lazy' />

                  </picture>
               </figure>
               )}
            </div>

            {cards.length !== 0 && <div className="cards">
               {cards.map((card, index) => (
                  <div className="card" key={index}>
                     <div className="title">{card.title}</div>
                     <div className="content">{card.content}</div>
                  </div>
               ))}
            </div>}

            <div className="cta">
               {cta.url && <Button className={`btn btn--${color === 'primary' ? 'primary' : 'secondary'} btn--icon`} href={cta.url} target={cta.isExternal} size={isMobile ? 'xs' : 'sm'} rightIcon='ArrowRight'>
                  {cta.label}
               </Button>}
            </div>
         </div>
      </div >
   )
}